import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as u } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, h = { key: 1 }, f = { key: 2 }, A = { key: 3 }, k = { key: 4 }, M = { key: 5 }, w = {
  name: "ScalarIconFunnelSimple"
}, V = /* @__PURE__ */ d({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: l } = Z(r);
    return (m, a) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      i(m.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", g, a[0] || (a[0] = [
        n("path", { d: "M204,136a12,12,0,0,1-12,12H64a12,12,0,0,1,0-24H192A12,12,0,0,1,204,136Zm28-60H24a12,12,0,0,0,0,24H232a12,12,0,0,0,0-24Zm-80,96H104a12,12,0,0,0,0,24h48a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", h, a[1] || (a[1] = [
        n("path", {
          d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", f, a[2] || (a[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM144,176H112a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Zm32-40H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm32-40H48a8,8,0,0,1,0-16H208a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", A, a[3] || (a[3] = [
        n("path", { d: "M198,136a6,6,0,0,1-6,6H64a6,6,0,0,1,0-12H192A6,6,0,0,1,198,136Zm34-54H24a6,6,0,0,0,0,12H232a6,6,0,0,0,0-12Zm-80,96H104a6,6,0,0,0,0,12h48a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", k, a[4] || (a[4] = [
        n("path", { d: "M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", M, a[5] || (a[5] = [
        n("path", { d: "M196,136a4,4,0,0,1-4,4H64a4,4,0,0,1,0-8H192A4,4,0,0,1,196,136Zm36-52H24a4,4,0,0,0,0,8H232a4,4,0,0,0,0-8Zm-80,96H104a4,4,0,0,0,0,8h48a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  V as default
};
